module.exports = __webpack_public_path__ + "img/2261@2x.07777178.png";